import React, { useEffect } from 'react';
import { setNavigationTitle, setNavigationSubTitle } from '../../Store/Actions/navigationHeaderActions';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setCurrentChatId, setCurrentLocation } from '../../Store/Actions/environmentActions';

interface CustomRouteProps {
    title: string;
    subTitle: string;
    children: React.ReactNode;
}

export const RouteWrapper: React.FC<CustomRouteProps> = ({ title, subTitle, children }) => {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        dispatch(setCurrentLocation(location.pathname));
        dispatch(
            setCurrentChatId(
                location.pathname.includes('chats') ? location.pathname.split('/').pop()?.toString() || '' : '',
            ),
        );
    }, [dispatch, location.pathname]);

    useEffect(() => {
        title !== '' && dispatch(setNavigationTitle(title));
        subTitle !== '' && dispatch(setNavigationSubTitle(subTitle));
    }, [dispatch, title, subTitle]);

    return <>{children}</>;
};
